module.exports = __webpack_public_path__ + "img/covericon03.ebb5d26c.png";